<template>
  <div class="navbar-dashboard-container">
    <div class="navbar-dashboard">
      <p class="navbar-dashboard-title" v-html="getCurrentMenu.title"/>
      <item-navbar-usuario class="navbar-usuario"></item-navbar-usuario>
    </div>
    <div v-if="getCurrentMenu.showChilds" :key="funcionalidade">
      <div style="height: 30px; overflow-y: hidden">
        <el-menu class="navbar-dashboard-functionalites" :router="true" mode="horizontal">
          <template v-for="(menu, index) in getCurrentMenu.childs">
            <el-menu-item v-show="(menu.idMenu !== 502 && !isUnimed) || (isUnimed)" :key="index"
                          :route="{path: getPath(menu.routerPath)}" :index='String(menu.idMenu)'
                          :class="(menu.routerName === getCurrentMenu.currentRouterName)?'is-active':''">
              <template v-if="menu.externalLink">
                {{ menu.name }}
                <i class="material-icons-round icon_externalLink">open_in_new</i>
              </template>
              <template v-else>
                {{ menu.name }}
              </template>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import ItemNavbarUsuario from '../ItemNavbarUsuario.vue'
import { mapState } from 'vuex'
import { isUnimed, searchMenuToId } from '@/utils/utils'
import enumTipoAplicacao from '@mobilesaude/frontend_libs/enums/enumTipoAplicacao'

export default {
  name: 'NavbarDashboard',
  components: {
    ItemNavbarUsuario
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'menus'
    ]),
    ...mapState('SelecionaAplicacao', ['aplicacoes']),
    funcionalidade () {
      return this.$route.params.funcionalidade || ''
    },
    aplicacao () {
      if (!this.idConfigClienteApp) {
        return null
      }
      return this.aplicacoes.find(
        app => `${app.id_cliente_app}` === this.idConfigClienteApp
      ) || null
    },
    isUnimed () {
      return isUnimed()
    },
    getCurrentMenu () {
      let menusFiltered = { ...searchMenuToId(this.menus, this.funcionalidade).menu }

      if (`${this.idConfigClienteApp}`) {
        if (this.aplicacao && this.aplicacao.tipo_aplicacao === enumTipoAplicacao.tipoPlataformas.atendimento) {
          return {}
        }

        if (this.aplicacao) {
          menusFiltered = {
            ...menusFiltered,
            childs: (menusFiltered.childs || []).filter(child => child.tipoAplicacao.includes(this.aplicacao.tipo_aplicacao))
          }
        } else {
          menusFiltered = {
            ...menusFiltered,
            childs: (menusFiltered.childs || []).filter(child => child.tipoAplicacao.length === 0)
          }
        }
        return menusFiltered
      }
      return menusFiltered
    },
    idConfigClienteApp () {
      return this.$route.params.idConfigClienteApp || ''
    }
  },
  methods: {
    getPath (path) {
      return path.replace(':idConfigClienteApp', this.idConfigClienteApp)
    }
  }
}
</script>
<style scoped lang="sass">
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../navbar-dashboard/navbar-dashboard.scss'
</style>
